import { isMinPremAccess$ } from '@op/services'
import { setGuardModal } from '../reducers/app-misc.slice'
import { _setPairDeviceViewState } from '../reducers/pair.slice'
import type { OPThunkP, PairDeviceViewState } from '../types'
import { canAddChildDevice, canAddChildUser } from './can-activate'

export const setPairDeviceView =
	(viewState: Maybe<PairDeviceViewState>): OPThunkP =>
	async (dispatch, getState) => {
		/**
		 * - We always allow clearing the view state
		 * - We always allow showing the Pair Comparison modal
		 */
		if (!viewState || viewState.view == 'pair_comparison') {
			dispatch(_setPairDeviceViewState(viewState))
			return
		}

		// For other views, we do an async check, so show the loading view. In cases where the
		// async check is immediate due to fetch bailout, this isn't noticable.
		dispatch(_setPairDeviceViewState({ view: 'loading' }))

		/**
		 * NOTE: This is structured as a switch becaused it's easier to read, even if it's a bit less
		 * compact. This is in contrast to: `if (add_child) {addChildCheck} else {addDeviceCheck}`,
		 * which makes the 'quick_pair' and 'select_child' implicit.
		 */
		switch (viewState.view) {
			/**
			 * For 'add_child', we check if we have reached the child limit. If we have, we clear the
			 * PairDeviceViewState and show the appropriate guard modal.
			 */
			case 'add_child': {
				if (!(await dispatch(canAddChildUser()))) {
					viewState = null
					dispatch(setGuardModal('max_children'))
				}

				break
			}

			/**
			 * For 'quick_pair' and 'select_child', we check if we've reached the device limit. If we
			 * have, we clear the PairDeviceViewState and show the appropriate guard modal.
			 */
			case 'quick_pair':
			case 'select_child': {
				if (!(await dispatch(canAddChildDevice()))) {
					viewState = null
					dispatch(
						setGuardModal(isMinPremAccess$(getState()) ? 'max_devices_contact' : 'max_devices'),
					)
				}

				break
			}
		}

		dispatch(_setPairDeviceViewState(viewState))
	}
